import { put, takeLatest } from 'typed-redux-saga/macro';
import { getUser } from 'actions';
import { REDEEM_EMPLOYER_BENEFIT_SUCCESS } from 'actions/types/organisations';
import { getBillingHistory } from '../actions/billingHistory';
import { IAP_PURCHASE_FLOW_ENDED_WITH_SUCCESS } from '../actions/iapSubscriptions';
import { REDEEM_STRIPE_GIFT_SUCCESS } from '../actions/types';
import { getStripeCredit } from '../actions/stripe';
const BILLING_HISTORY_REFETCH_TRIGGERS = [
    'PURCHASE_EXTRA_MEMBER_SLOTS_SUCCESS',
    'SUBSCRIBE_VIA_STRIPE_SUCCESS',
    'CHANGE_SUBSCRIPTION_VIA_STRIPE_SUCCESS',
    'CANCEL_STRIPE_SUBSCRIPTION_SUCCESS',
    'REACTIVATE_STRIPE_SUBSCRIPTION_SUCCESS',
    'EXTEND_TRIAL_VIA_STRIPE_SUCCESS',
    'REFUND_STRIPE_SUBSCRIPTION_SUCCESS',
    IAP_PURCHASE_FLOW_ENDED_WITH_SUCCESS,
    REDEEM_STRIPE_GIFT_SUCCESS,
    REDEEM_EMPLOYER_BENEFIT_SUCCESS,
];
function isBillingTrigger(action) {
    return BILLING_HISTORY_REFETCH_TRIGGERS.includes(action.type);
}
function* updateBillingWorker() {
    yield* put(getBillingHistory({ page: 1 }));
    yield* put(getStripeCredit());
}
function* fetchUserWorker(action) {
    if (action.extra.isLeaveFlow) {
        yield* put(getUser());
    }
}
function* billingSagas() {
    yield* takeLatest(isBillingTrigger, updateBillingWorker);
    yield* takeLatest('REMOVE_EXTRA_MEMBER_SUCCESS', fetchUserWorker);
}
export default billingSagas;
